import React from 'react';
import { Link } from 'react-router-dom';

const ALink = ({ useLink, href, children, ...otherProps }) => {
    if (useLink) {
        // Strip away origin for local links
        let to = href;
        if (href?.startsWith(location.origin)) {
            const { pathname, search } = new URL(href);
            to = pathname + search;
        }
        return (
            <Link to={to} {...otherProps}>
                {children}
            </Link>
        );
    } else {
        return (
            <a href={href} {...otherProps}>
                {children}
            </a>
        );
    }
};

export default ALink;
